import { formatSaleStatus, formatCurrencyInt } from '@edge/spark/utils'
import type { SearchVehicle } from '../types'

export const status = ({ status: _status, saleAmount }: SearchVehicle): string => {
    const formattedStatus = formatSaleStatus(_status) || ''
    const formattedAmount = formatCurrencyInt(saleAmount) || ''

    return formattedStatus === 'Sold' ? `${formattedStatus}: ${formattedAmount}` : formattedStatus
}
